module.exports = __webpack_public_path__ + "img/supporto_auto_hdtool.503351c3.png";